<button mat-stroked-button *ngIf="selection == null" style="margin-bottom: 15px; width: 100%" (click)="onSearch()">
    {{ text }}
</button>
<div *ngIf="selection != null" style="margin-bottom: 15px" [matTooltip]="selection.name">
    <strong>{{ selection.code }}</strong>
    <a (click)="onClear()" style="padding-left: 5px; color: brown; font-size: 75%; cursor: pointer">{{ "Clear" | localize }}</a>
    <br>{{ selection.name | dotdotdot:20 }}
</div>